import { login } from "../../services/Auth";
import { LOGIN_SUCCESS, LOGIN_ERROR } from "../slices/authenticationSlice";
export const loginAction = (authData) => async (dispatch) => {
  const res = await login(authData);
  if (res?.data?.jwtToken) {
    localStorage.setItem("token", "Bearer " + res?.data?.jwtToken);
    localStorage.setItem("userEmail", res?.data?.user?.email);
    localStorage.setItem("userName", res?.data?.user?.name);
    localStorage.setItem("userTypeId", res?.data?.user?.userTypeId);
    localStorage.setItem("companyId", res?.data?.user?.companyId);
    localStorage.setItem("companyLogo", res?.data?.companyLogo);
    localStorage.setItem("companyName", res?.data?.companyName);
    dispatch(LOGIN_SUCCESS(res?.data));
    return res;
  } else {
    dispatch(LOGIN_ERROR("Error"));
    return res;
  }
};
